const initFilters = () => {
   const filters = document.querySelectorAll('[data-filter]');
   const items = document.querySelectorAll('[data-filter-item]');
   const titlePO = document.querySelector('.catalog__courses-title-po');
   const itemsPO = document.querySelector('.catalog__tiles-po')? document.querySelector('.catalog__tiles-po').children : '';

     
   let active = document.querySelector('.active[data-filter]');

   filters.length && items.length && filters.forEach(filter => {
      filter.addEventListener('click', () => {
         let direction = filter.getAttribute('data-direction');

         filter.classList.add('active');
         active.classList.remove('active');
         active = filter;

         items.forEach((item) => {
            switch (direction) {
               case 'all':
                  item.style.display = 'flex';
                  break;
               case item.getAttribute('data-direction'):
                  item.style.display = 'flex';
                  item.style.opacity = '1';
                  break;
               default:
                  item.style.display = 'none';
                  break;
            };
         });
         
         /*Скрытие заголовка для категории PO, если там нет карточек */
         if (
            [...itemsPO].filter((item) => item.style.display !== "none")
              .length == 0
          ) {
            titlePO.style.display = "none";
          } else {
            titlePO.style.display = "block";
          }
      })
   })
   
};
 
export default initFilters;
